import { colors, spacing, subtitle1 } from 'ui/theme';
import styled from 'styled-components';
import { Skeleton } from 'ui/skeleton';
import { EmailContentDefinition } from 'modules/graphql/types/GraphQLTemplate';

const Subject = styled.div`
  ${subtitle1};
  border-bottom: 1px solid ${colors.borderPrimarySubtle};
  padding-bottom: ${spacing.threeQuarter};
  margin-bottom: ${spacing.threeQuarter};
`;

export const EmailPreviewSubject = ({
  templateData,
  isTemplateDataLoading,
}: {
  templateData: EmailContentDefinition;
  isTemplateDataLoading: boolean;
}) => {
  const subject = templateData?.subject;

  if (isTemplateDataLoading) {
    return (
      <Subject>
        <Skeleton />
      </Subject>
    );
  }

  if (!subject) return null;

  return <Subject>{subject}</Subject>;
};
